import { useCurrentProjectId, useCurrentToolId } from '@adsk/alloy-provider';

import { getBaseScheduleFEUrl } from '../../helpers';
import { ScheduleActivityEntity } from '../types';

/**
 * Get the URL to the plan task link.
 */
export const useScheduleActivityLink = (activity: ScheduleActivityEntity) => {
  const scheduleBaseUrl = getBaseScheduleFEUrl();
  const projectId = useCurrentProjectId();
  const currentProduct = useCurrentProjectId();
  const currentTool = useCurrentToolId();
  const sourceAnalytics = `source_product=${currentProduct}&source_tool=${currentTool}`;

  return `${scheduleBaseUrl}/projects/${projectId}/schedules/${activity.scheduleId}?activityId=${activity.uniqueId}&${sourceAnalytics}`;
};
